import { useQuery } from "@tanstack/react-query";
import { api } from "./config";

export type ServiceTimesResponse = {
    eegAllowedTimesWeek: Array<string>;
    eegAllowedTimesSaturday: Array<string>;
    feedbackMeetingAllowedTimes: Array<string>;
    nfbAllowedTimesSaturdayNew: Array<string>;
    nfbAllowedTimesWeekNew: Array<string>;
    psyAllowedTimes: Array<string>;
    reportsAllowedTimes: Array<string>;
};

const fetchServiceTimes = async () => {
    const response = await api({
        method: "GET",
        url: "/availabilities-finder/service-times",
    });
    return response.data as ServiceTimesResponse;
};

export const useServiceTimes = () => {
    return useQuery({
        queryKey: ["service-times"],
        queryFn: fetchServiceTimes,
        staleTime: Infinity,
    });
};

